import React, { createContext, useState, useContext } from "react";

// Create Context
const LoadingContext = createContext();

// Custom Hook for Easy Access
export const useLoading = () => useContext(LoadingContext);

// Provider Component
export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false); // ✅ Fix: Ensure this exists

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};